import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {ConnectionService} from './connection.service';
import {AppConfig} from '../app.config';
import {Observable} from 'rxjs/Observable';
import {TaskActivity} from '../entities/TaskActivity';
import {RequestInterceptor} from "./Interceptors/RequestInterceptor";

@Injectable()
export class TaskActivityService {
  private readonly apiUrl: string;

  constructor(
    private requestInterceptor: RequestInterceptor,
    private http: Http,
    private connectionService: ConnectionService,
    private config: AppConfig
  ) {
    this.apiUrl = config.getConfig('endPointApiUrl');
  }

  private getHeaders(company = null): RequestOptions {
    const headers: Headers = this.connectionService.GetAuthorizationHeader(company);
    return new RequestOptions({ headers });
  }

  getActivities(taskGuid: string): Observable<TaskActivity[]> {
    const url: string = `${this.apiUrl}api/TaskActivities/GetTaskActivities/${taskGuid}`;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as TaskActivity[]);
  }

  getActivityHistory(
    maintenanceObjectNo: string,
    taskActivityNo: number,
    maintenanceTemplateNo: number
  ): Observable<TaskActivity[]> {
    const url: string = `${this.apiUrl}api/TaskActivities/GetActivityHistory/${maintenanceObjectNo}/${taskActivityNo}/${maintenanceTemplateNo}`;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json());
  }

  putTaskActivities(activities: TaskActivity[]): Observable<any> {
    const url: string = `${this.apiUrl}api/TaskActivities/UpdateTaskActivitiesStatus`;

    return this.http
      .put(url, JSON.stringify(activities), this.getHeaders());
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/task-activity.service.ts